<script>
  import ButtonContainer from "@helpers/ButtonContainer.svelte";
  import IntersectionObserver from "svelte-intersection-observer";

  let element;
  export let intersecting = false;

  let number = 1;
  $: zeroes = "1" + "0".repeat(number);
  $: displayedNum = 51 * +zeroes;

  import { format } from "d3-format";
  let comma = format(",~f");

  function suffix(labelValue) {
    return Number(labelValue) >= 1.0e12
      ? Number(labelValue) / 1.0e12 + " trillion"
      : Number(labelValue) >= 1.0e9
      ? Number(labelValue) / 1.0e9 + " billion"
      : Number(labelValue) >= 1.0e6
      ? Number(labelValue) / 1.0e6 + " million"
      : Number(labelValue) >= 1.0e3
      ? Number(labelValue) / 1.0e3 + " thousand"
      : Number(labelValue);
  }

  import { guessIsCorrect } from "@stores/userData.js";
  import navigateToHash from "@helpers/navigateToHash.js";
  let buttonText = "This is it!";
  let submitGuess = () => {
    guessIsCorrect.set(number === 8);
    buttonText = $guessIsCorrect ? "You got it!" : "Not quite...";
    navigateToHash("other-cities", 500);
  };

  import Emoji from "@helpers/Emoji.svelte";
</script>

<IntersectionObserver {element} bind:intersecting>
  <section bind:this={element} id="introduction">
    <div class="prose">
      <h1 class="section-title">
        How much are we working
        <span class="emoji-follows accent-text" data-emoji="🤔"
          >with?<Emoji emoji="think" /></span
        >
      </h1>
      <p class="body-text">
        Let's start with the big picture. What do you think the size of
        Houston's budget was in <span class="with-tooltip"
          ><span class="tooltip text"
            >The city's fiscal year runs from July to June. Fiscal Year 2022
            includes money received and spent from July 1, 2021 - June 30, 2022.
          </span>Fiscal Year 2022</span
        > (FY2022)? We'll give you a hint—it starts with 51:
      </p>
      <p class="direction-text">
        <label for="guess">
          Click and drag the slider to change the amount to what you think.
        </label>
      </p>
      <div class="guess">
        <h2 class="number">
          ${comma(displayedNum)}
        </h2>
        <input
          type="range"
          name="guess"
          id="guess"
          bind:value={number}
          min="1"
          max="11"
        />
        <div class="bottom">
          <span class="helper"
            >{number > 5 ? `($${suffix(displayedNum)})` : "​​"}</span
          >
          <ButtonContainer styles="margin: 0 0 0 auto;">
            <button on:click={submitGuess}>{buttonText}</button>
          </ButtonContainer>
        </div>
      </div>
    </div>
  </section>
</IntersectionObserver>

<style>
  section {
    text-align: left;
    padding: 5rem 1rem 5rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
    border: 1px solid rgba(var(--text-color-rgb), 0.25);
  }

  .emoji-follows:before {
    bottom: -0.75rem;
    right: -5rem;
  }

  .guess {
    margin-top: 1.25rem;
  }

  input[type="range"] {
    width: 100%;
    margin-bottom: 0.5rem;
    cursor: pointer;
  }

  h2 {
    font-size: min(8vw, 4rem);
    font-weight: 900;
    /* font-variant: tabular-nums; */
    margin-bottom: 0.5rem;
    text-align: center;
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    place-items: center;
  }

  .helper {
    padding: 0.5rem 1rem;
  }

  .helper {
    font-family: var(--font-serif);
    font-weight: 200;
    font-size: 1.75rem;
  }

  .number {
    position: relative;
  }
</style>
